import React from 'react';
import { Fab } from '@one-thd/sui-atomic-components';
import { ImpressionProvider, useImpression } from '@thd-olt-component-react/impression';
import classNames from 'classnames';
import { AssistantIcon } from './AssistantIcon';

export const AssistantActionButton = ({ onClick, isMobile }) => {

  const fabContainerClasses = classNames(
    'sui-z-max sui-bottom-4 sui-right-2',
    {
      'sui-absolute': isMobile,
      'sui-fixed xl:sui-bottom-10 xl:sui-right-10': !isMobile,
    }
  );

  const impressionData = {
    id: '00DEFVALMA00',
    name: 'MagicApronAssistant',
    component: 'MagicApronLoader',
    type: 'content',
  };

  const { ref, clickID } = useImpression({ data: {
    id: '00DEFVALMA00', // *** required prop ***
    component: 'MagicApronAssistant', // *** required prop *** ==> component public export name
    name: 'MagicApronAssistant', // *** required prop *** ==> descriptive titles or component name
    variation: 'component', // cta style values
    position: '1',
    type: 'content',
    category: 'content',
  } });

  return (
    <div className={fabContainerClasses}>
      <ImpressionProvider data={impressionData}>
        <Fab aria-label="Magic Apron Assistant Action Button" onClick={onClick} ref={ref} clickid={clickID}>
          <AssistantIcon color="inverse" />
        </Fab>
      </ImpressionProvider>
    </div>
  );
};